export const SERVER_CATEGORY_TREE_DISPLAY_ID =
  'SERVER_CATEGORY_TREE_DISPLAY_ID';
